import { Link } from "react-router-dom";
import { Youtube, Sparkles } from "lucide-react";
import { LOGO_URL, YOUTUBE_URL } from "../lib/brand";
import Seo from "../components/Seo";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16" data-testid="about-page">
      <Seo
        title="About Anthony's Playworld"
        path="/about"
        description="Meet Anthony's Playworld — the YouTube channel packed with toys, songs and colorful adventures. Learn about the crew behind the videos and how every merch purchase keeps the fun rolling."
      />
      <img
        src={LOGO_URL}
        alt="Anthony's Playworld"
        className="pw-logo-img w-40 h-40 object-contain mb-8"
      />
      <span className="pw-badge yellow inline-block mb-4">ABOUT US</span>
      <h1 className="font-display text-5xl sm:text-6xl uppercase leading-none mb-6">
        Welcome to <span className="bg-[#FF2E93] text-white border-3 border-black px-2 inline-block -rotate-2" style={{borderWidth:3}}>Playworld</span>
      </h1>
      <p className="text-lg leading-relaxed mb-6">
        Anthony&apos;s Playworld is a YouTube channel filled with imagination,
        laughter, and big colorful adventures. Every video is packed with toys,
        games, songs and friends — the kind of stuff that makes kids cheer and
        parents smile. From backyard treasure hunts to bedtime songs, from
        rainbow snack recipes to giant-cardboard-castle builds, our episodes
        are designed to celebrate the everyday magic of being a kid.
      </p>
      <p className="text-lg leading-relaxed mb-6">
        This merch store brings the Playworld universe into your everyday life.
        From cozy hoodies to huggable plush pals, every piece is designed with
        bright colors, real personality and kid-friendly comfort. We work with
        small-batch US printers, use fade-resistant inks, and stock super-soft
        cotton so nothing feels itchy or stiff. Because when a kid picks their
        favorite shirt in the morning, they should feel like the star of their
        own adventure.
      </p>
      <p className="text-lg leading-relaxed mb-10">
        Every merch purchase supports new videos, new toys and new adventures on
        the channel — so thank you for being part of the crew. We can&apos;t
        wait to see your Playworld moments!
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12">
        {[
          { color: "#FFD500", title: "Made with Love", text: "Designed by fans, for fans of the Playworld crew." },
          { color: "#FF2E93", title: "Kid-Tested", text: "Comfy, durable and adventure-approved by real little humans." },
          { color: "#00E5FF", title: "Channel Powered", text: "A part of every purchase keeps the videos rolling." },
        ].map((c) => (
          <div key={c.title} className="pw-card p-6" style={{ background: c.color }}>
            <h3 className="font-display text-xl uppercase mb-2">{c.title}</h3>
            <p className="text-sm font-medium">{c.text}</p>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-4">
        <Link to="/shop" className="pw-btn">
          <Sparkles size={18} strokeWidth={3} className="mr-2" /> Shop Now
        </Link>
        <a
          href={YOUTUBE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="pw-btn pw-btn-blue"
        >
          <Youtube size={18} strokeWidth={3} className="mr-2" /> Watch on YouTube
        </a>
      </div>
    </div>
  );
}
